module.exports = __webpack_public_path__ + "img/banana-outlet-bk.08f95fe2.svg";